import React, { useState } from 'react';
import { Container, Form, Header } from 'semantic-ui-react';
import { DrawingCanvas } from './Draw.js';
import { requester } from './utils.js';

export function SignForm(props) {
	const { token } = props;
	const [error, setError] = useState({});
	const [sign, setSign] = useState('');
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const handleValues = (e, v) => setSign(v.value);
	const handleChange = (e) => handleValues(e, e.currentTarget);

	const handleSubmit = (e) => {
		if (loading) return;
		setLoading(true);
		const data = {sign: sign};
		requester('/stats/sign/', 'POST', token, data)
		.then(res => {
			setLoading(false);
			setSuccess(true);
			setError({});
			setSign('');
		})
		.catch(err => {
			setLoading(false);
			console.log(err);
			setError(err.data);
		});
	};

	return (
		<Form onSubmit={handleSubmit}>
			<p>Send a message to the sign + Vestaboard:</p>

			<Form.Group widths='equal'>
				<Form.Input
					name='sign'
					onChange={handleChange}
					value={sign}
					error={error.sign}
					data-testid='sign-and-vestaboard-input'
				/>

				<Form.Button loading={loading} error={error.non_field_errors} data-testid='sign-and-vestaboard-submit'>
					Submit
				</Form.Button>
			</Form.Group>
			{success && <div>Success!</div>}
		</Form>
	);
};

export function VestaboardForm(props) {
	const { token } = props;
	const [error, setError] = useState({});
	const [sign, setSign] = useState('');
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [isFocused, setIsFocused] = useState(false);

	const handleValues = (e, v) => setSign(v.value);
	const handleChange = (e) => handleValues(e, e.currentTarget);

	const handleSubmit = (e) => {
		if (loading) return;
		setLoading(true);
		const data = {vestaboard: sign};
		requester('/stats/vestaboard/', 'POST', token, data)
		.then(res => {
			setLoading(false);
			setSuccess(true);
			setError({});
			setSign('');
		})
		.catch(err => {
			setLoading(false);
			console.log(err);
			setError(err.data);
		});
	};

	return (
		<Form onSubmit={handleSubmit}>
			<p>Send a message to the Vestaboard only:</p>

			<Form.Group widths='equal'>
				<Form.Input
					name='sign'
					onChange={handleChange}
					value={sign}
					error={error.sign}
					onFocus={() => setIsFocused(true)}
					onBlur={() => setIsFocused(false)}
					data-testid='vestaboard-only-input'
				/>

				<Form.Button loading={loading} error={error.non_field_errors} data-testid='vestaboard-only-submit'>
					Submit
				</Form.Button>

			</Form.Group>

			{success && <p>Success!</p>}

			{isFocused && <p style={{marginTop: '-0.5rem'}}>
				Special:
				\w = ▒,
				\r = <span style={{color: 'red'}}>█</span>,
				\o = <span style={{color: 'orange'}}>█</span>,
				\y = <span style={{color: 'yellow'}}>█</span>,
				\g = <span style={{color: 'green'}}>█</span>,
				\b = <span style={{color: 'blue'}}>█</span>,
				\v = <span style={{color: 'violet'}}>█</span>,
				\d = °
			</p>}
		</Form>
	);
};


export function Sign(props) {
	const { token, user } = props;

	return (
		<Container>
			<Header size='large'>Protospace Sign / Drawing</Header>

			<SignForm token={token} />

			<VestaboardForm token={token} />

			<DrawingCanvas user={user} token={token} />
		</Container>
	);
};
